import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "template-list",
    templateUrl: "./template-list.component.html",
    styleUrls: ["./template-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule
    ]
})
export class TemplateListComponent {

    @Input({required: true})
    timelineItemContent!: string;

    @Input({required: true})
    templates: string[];

    @Output()
    onSelect: EventEmitter<string> = new EventEmitter();


    select(template: string) {
        this.timelineItemContent = template;
        this.onSelect.emit(this.timelineItemContent);
    }
}